import mixpanel from 'mixpanel-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NgxPermissionsModule } from 'ngx-permissions';

import * as Sentry from '@sentry/angular';

import { JwtModule } from '@auth0/angular-jwt';
import { reducers, effects, DataAccessStoreModule, CustomSerializer } from '@unico-people/shared/dashboard/data-access-store';

import { environment } from '../environments/environment';

export function tokenGetter() {
  return   getTokenStorage();
}

import { AppComponent } from './app.component';
import { SegmentModule } from 'ngx-segment-analytics';
import { RouterStateSerializer } from '@ngrx/router-store';
import { TokenInterceptor } from '@unico-people/utils-interceptor';
import { LaunchdarklyService } from '@acesso-io/launchdarkly-client-ts/lib/launchdarkly';
import { Router } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import * as ld from 'launchdarkly-js-client-sdk';
import { getTokenStorage } from '@unico-people/shared/utils/storage';

const context = {
  anonymous: true,
  custom: {
     "appName": "benefits"
  },
} as ld.LDContext;

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgxPermissionsModule.forRoot(),
    StoreModule.forRoot(reducers, {
      metaReducers: !environment.production ? [] : [],
      runtimeChecks: {
        strictActionImmutability: true,
        strictStateImmutability: true
      }
    }),
    EffectsModule.forRoot(effects),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    SegmentModule.forRoot({ apiKey: '', debug: false, loadOnInitialization: false }),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter
      }
    }),
    DataAccessStoreModule,
    MatDialogModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: RouterStateSerializer, useClass: CustomSerializer },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    { provide: LaunchdarklyService, useFactory: () => new LaunchdarklyService(environment.launchDarklyClientId)},
    {
      provide: APP_INITIALIZER,
      useFactory: (ld: LaunchdarklyService) => async () => {
        // todo: use organization and user id to set ld context
        await ld.init({ context })

        mixpanel.init(
          environment.mixpanel_token,
          { debug: !environment.production, track_pageview: true, persistence: 'localStorage' }
        )
      },
      multi: true,
      deps: [LaunchdarklyService],
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
